import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import './approval.css'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import ApprovalService from '../../services/approval.service'
import { NeoOTP, NeoSuccess } from '../../components/FormComponents'
import Loading from 'custom/assets/loaders/Loading'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import { getRoleAccessKeySelector , getMenuListSelector} from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import MediumModal from '../../components/Modal/MediumModel'
import DownloadIcon from 'custom/assets/common-icons/Download.svg'
import NotificationService from '../../services/notification.service'
import InputError from '../../components/InputError/InputError'
import { ApprovalSchema } from '../../schemas/requests'
import CustomPagination from '../../components/pagination'
import SalaryUploadDetails from '../../components/view-details/salaryUpload'
import SalaryUploadHeaderDetails from '../../components/header-details/salaryUpload'
import { Checkbox } from 'antd'
import NumberFormat from 'react-number-format'
import ViewComments from './../../components/comments-details/view-comment'
import {
  BUTTON_KEYS,
  APPROVAL_COMMON_KEYS,
  APPROVAL_SALARY_UPLOAD_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
const approvalConfig = validationConfig['approval']

export default function ApprovalSalaryUpload() {
  const history = useHistory()
  const roleAccessKey = useSelector(getRoleAccessKeySelector)
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [isApprove, setIsApprove] = useState(false)
  const [isReject, setIsReject] = useState(false)
  const [otp, setOtp] = useState('')
  const [noRecords, setNoRecords] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [selectedDetails, setSelectedDetails] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [responseList, setResponseList] = useState([])
  const [expanded, setExpanded] = useState(null)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(5)
  const [selectedRecords, setSelectedRecords] = useState([])
  const [selectedReqIds, setSelectedReqIds] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkAll, setCheckAll] = useState(false)
  const [tabIndex, setTabIndex] = useState(1)
  const [authCommentsList, setAuthCommentsList] = useState([])
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['APPROVAL'] || {}

  const [showConfirmModal, hideConfirmModal] = useModal(
    () => (
      <MediumModal bgBlur={true}>
        <div className='row' style={{ width: 350 }}>
          <div className='col-2'>
            <img src={null} style={{ marginTop: 20 }} />
          </div>

          <div className='col-10'>
            <div className='my-4'>
              <h6 className='font-weight-bolder log-out-text' style={{ fontStyle: 18 }}>
                {t(APPROVAL_COMMON_KEYS.DELETE_MESSAGE)}
              </h6>
            </div>
            <div className='row'>
              <div className='col-6'>
                {loading === false ? (
                  <NeoButton
                    mode='newDesign'
                    onClick={() => onDelete(selectedDetails)}
                    text={t(BUTTON_KEYS.YES)}
                    type='button'
                  />
                ) : (
                  renderLoading()
                )}
              </div>
              <div className='col-6'>
                <div
                  style={{ textAlign: 'left', marginTop: 10 }}
                  className='back-cancel-style'
                  onClick={hideConfirmModal}>
                  {t(BUTTON_KEYS.CANCEL)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </MediumModal>
    ),
    [loading, selectedDetails],
  )

  useEffect(() => {
    getSalaryUploadList()
  }, [])

  const getSalaryUploadList = useCallback(async () => {
    try {
      const response = await ApprovalService.getSalaryUploadList({ listType: 'PENDING' })
      if (response.status === 200) {
        setStage(1)
        setNoRecords(response.data['requestList']?.length > 0 ? false : true)
        response.data['requestList'].forEach((element) => {
          element.isChecked = false
        })
        setDataSource(response.data['requestList'])
      }
    } catch (err) {}
  }, [])

  const handleApproveSelect = useCallback(async (selected) => {
    try {
      setIsApprove(true)
      setSelectedDetails(selected)
      setSelectedReqIds([selected.reqId])
      setStage(2)
    } catch (err) {}
  }, [])
  const handleRejectSelect = useCallback(async (selected) => {
    try {
      setIsReject(true)
      setSelectedDetails(selected)
      setSelectedReqIds([selected.reqId])
      setStage(2)
    } catch (err) {}
  }, [])

  const handleDeleteSelect = useCallback(async (selected) => {
    try {
      // setIsReject(true)
      setSelectedDetails(selected)
      // setStage(2)
      showConfirmModal()
    } catch (err) {}
  }, [])

  const handleMultiApproveSelect = useCallback(() => {
    try {
      const selectedReqs = []
      selectedRecords.forEach((ele) => {
        selectedReqs.push(ele.reqId)
      })
      setSelectedReqIds(selectedReqs)
      setIsApprove(true)
      setStage(2)
    } catch (err) {}
  }, [selectedRecords])

  const handleMultiRejectSelect = useCallback(() => {
    try {
      const selectedReqs = []
      selectedRecords.forEach((ele) => {
        selectedReqs.push(ele.reqId)
      })
      setSelectedReqIds(selectedReqs)
      setIsReject(true)
      setStage(2)
    } catch (err) {}
  }, [selectedRecords])

  const onVerify = useCallback(
    async (values) => {
      try {
        setLoading(true)
        setFormValues(values)
        const reqParams = {
          reqIds: selectedReqIds,
          authType: isApprove ? 'A' : 'R',
        }
        const response = await ApprovalService.salaryUploadVerifyAuthRequest(reqParams)
        if (response.status === 200) {
          setVerifyDetails(response.data)
          if (response.data['otpEnable']) {
            setLoading(false)
            setStage(3)
            return
          }
          const authComments = []
          selectedReqIds.forEach((ele) => {
            authComments.push({ authorizerComments: values.comments, reqId: ele })
          })
          const response1 = await ApprovalService.salaryUploadConfirmAuthRequest({
            authReqList: authComments,
            otp: otp || '0000',
            randomKey: response.data['randomKey'],
            authType: isApprove ? 'A' : 'R',
          })
          if (response1.status === 200) {
            setResponseList(response1.data['authResponseList'])
            setLoading(false)
            setStage(4)
          }
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [selectedDetails, isApprove, selectedReqIds],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const authComments = []
      selectedReqIds.forEach((ele) => {
        authComments.push({ authorizerComments: formValues.comments, reqId: ele })
      })
      const reqParams = {
        authReqList: authComments,
        otp: otp || '0000',
        randomKey: verifyDetails.randomKey,
        authType: isApprove ? 'A' : 'R',
      }
      const response = await ApprovalService.salaryUploadConfirmAuthRequest(reqParams)
      if (response.status === 200) {
        setResponseList(response.data['authResponseList'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [verifyDetails, formValues, otp, selectedDetails, isReject, isApprove, selectedReqIds])

  const onDelete = useCallback(async (values) => {
    try {
      setLoading(true)
      const reqParams = {
        reqId: values.reqId,
      }
      const response = await ApprovalService.salaryUploadDelete(reqParams)
      if (response.status === 200) {
        NotificationService.showSuccessMessage(response.data['message'])
        //setExpanded(null)
        setLoading(false)
        hideConfirmModal()
        setStage(0)
        await getSalaryUploadList()
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])
  const handleSelectAll = useCallback(
    (value) => {
      try {
        const dataSourceCopy = [...dataSource]
        dataSourceCopy.forEach((ele) => (ele.isChecked = value))
        setDataSource(dataSourceCopy)
        setSelectedRecords(value ? dataSourceCopy : [])
        setCheckAll(value)
      } catch (err) {}
    },
    [dataSource],
  )

  const handleCheckBoxChange = useCallback(
    (value, selected) => {
      try {
        const dataSourceCopy = [...dataSource]
        let selectedRecordsCopy = [...selectedRecords]
        dataSourceCopy.forEach((ele) => {
          if (ele.reqId === selected.reqId) {
            ele.isChecked = value
          }
        })
        if (value) {
          selectedRecordsCopy.push(selected)
        } else {
          selectedRecordsCopy = selectedRecordsCopy.filter((ele) => ele.reqId !== selected.reqId)
        }

        setDataSource(dataSourceCopy)
        setSelectedRecords(selectedRecordsCopy)

        setIndeterminate(
          selectedRecordsCopy.length === 0
            ? false
            : selectedRecordsCopy.length < dataSourceCopy.length
            ? true
            : false,
        )
        setCheckAll(selectedRecordsCopy.length === dataSourceCopy.length)
      } catch (err) {}
    },
    [dataSource, selectedRecords],
  )

  const onDownload = useCallback(async () => {
    try {
      await ApprovalService.salaryUploadDownload({ listType: 'PENDING' })
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const downloadFile = useCallback(async (option) => {
    try {
      console.log(option)
      let request = {
        status: option.authStatus,
        userGroup: option.groupId,
        salaryUploadId: option.reqId,
      }
      await ApprovalService.salaryUploadDownloadView(request, option.file)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  // const onDownload = useCallback(async (selected) => {
  //   try {
  //     await ApprovalService.salaryUploadDownload({
  //       salaryUploadId: selected.reqId,
  //       status: selected.status,
  //     })
  //   } catch (err) {
  //     setLoading(false)
  //   }
  // }, [])

  const getSalaryUploadAuthComments = useCallback(async (selected) => {
    try {
      setAuthCommentsList([])
      setLoading(true)
      const response = await ApprovalService.getSalaryUploadAuthComments({ reqId: selected.reqId })
      if (response.status === 200) {
        setAuthCommentsList(response.data['authTrackList'])
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderList()
      case 2:
        return <div className='new-design-form-style'>{renderConfirmation()}</div>
      case 3:
        return (
          <div className='new-design-form-style'>
            <div className='heading-style'>{t(APPROVAL_SALARY_UPLOAD_KEYS.TITLE)}</div>
            <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
          </div>
        )
      case 4:
        return renderSuccess()
      default:
        return renderLoading()
    }
  }

  function renderList() {
    return (
      <>
        <div
          className='d-flex'
          style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div className='heading-style' style={{ margin: 0 }}>
            {t(APPROVAL_SALARY_UPLOAD_KEYS.TITLE)}
          </div>
          {menuConfig["SALARY_UPLOAD"] && (
          <button
            tabIndex={'1'}
            onClick={() => onDownload()}
            type='button'
            className='btn detailed-statement-btn'
            style={{ padding: '5px 25px' }}>
            <img src={DownloadIcon} alt='' className='mr-2' height={23} width={20} />
            <span className='font-weight-600'>{t(BUTTON_KEYS.DOWNLOAD)}</span>
          </button>
          )}
        </div>

        {noRecords && (
          <div className='no-data-found'>{t(APPROVAL_COMMON_KEYS.NO_RECORDS_FOUND)}</div>
        )}

        {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && dataSource.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 15 }}>
            <Checkbox
              checked={checkAll}
              indeterminate={indeterminate}
              onChange={(e) => handleSelectAll(e.target.checked)}>
              {t(APPROVAL_COMMON_KEYS.SELECT_ALL)}
            </Checkbox>
            {selectedRecords.length > 0 && (
              <div className='d-flex approve-reject-btn'>
                <a onClick={() => handleMultiApproveSelect()}>
                  {roleAccessKey === 'A'
                    ? t(APPROVAL_COMMON_KEYS.APPROVE)
                    : t(APPROVAL_COMMON_KEYS.VERIFY)}
                </a>
                <a onClick={() => handleMultiRejectSelect()}>{t(APPROVAL_COMMON_KEYS.REJECT)}</a>
              </div>
            )}
          </div>
        )}

        {dataSource.slice(minValue, maxValue).map((option, index) => (
          <div key={index} className='approval-card'>
            <div
              className=' '
              onClick={() => {
                setTabIndex(1)
                if (expanded == index) {
                  setExpanded(null)
                } else {
                  setExpanded(index)
                }
              }}>
              <div className='approval-card-header '>
                <span style={{ alignItems: 'center', display: 'flex' }}>
                  <span style={{ marginRight: 10 }}>
                    {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && (
                      <Checkbox
                        checked={option.isChecked}
                        onChange={(e) => {
                          setExpanded(null)
                          handleCheckBoxChange(e.target.checked, option)
                        }}></Checkbox>
                    )}
                  </span>
                  <span>
                    <span className='span1'>{'File Name'} : {option?.file}</span>
                    <span className='mt-2 span2'>
                      {t(APPROVAL_SALARY_UPLOAD_KEYS.SOURCE_ACCOUNT_NO)} : {option?.srcAccNo}
                    </span>
                    <span className='mt-2 span2'>
                      {t(APPROVAL_SALARY_UPLOAD_KEYS.BRANCH_CODE)} : {option?.srcAccBrn}
                    </span>
                  </span>
                </span>
                <span>
                  {option?.typeofFile === 'N' && (
                    <span className='span3'>
                      {t(APPROVAL_SALARY_UPLOAD_KEYS.TOTAL_AMOUNT)} : {option?.totalAmount}
                    </span>
                  )}

                  <span className='mt-2 span2 text-right'>
                    {option?.initDate !== null ? option?.initDate : '-'}
                  </span>
                </span>
              </div>
            </div>
            {expanded === index && (
              <div className='approval-card-body'>
                <div className='row tab-navbar'>
                  <div className={tabIndex === 1 ? 'col-6 selected' : 'col-6'}>
                    <span
                      onClick={() => {
                        setTabIndex(1)
                      }}>
                      {t(APPROVAL_COMMON_KEYS.VIEW_DETAILS)}
                    </span>
                  </div>
                  <div className={tabIndex === 2 ? 'col-6 selected' : 'col-6'}>
                    <span
                      onClick={() => {
                        setTabIndex(2)
                        getSalaryUploadAuthComments(option)
                      }}>
                      {t(APPROVAL_COMMON_KEYS.VIEW_COMMENTS)}
                    </span>
                  </div>
                </div>
                {tabIndex === 1 && (
                  <div>
                    <SalaryUploadDetails option={option} />
                    <div className='d-flex' style={{ marginTop: 20, justifyContent: 'center' }}>
                      {roleAccessKey !== 'I' && roleAccessKey !== 'VW' && selectedRecords.length === 0 && (
                        <div className='d-flex'>
                          <a onClick={() => handleApproveSelect(option)}>
                            {roleAccessKey === 'A'
                              ? t(APPROVAL_COMMON_KEYS.APPROVE)
                              : t(APPROVAL_COMMON_KEYS.VERIFY)}
                          </a>
                          <a onClick={() => handleRejectSelect(option)}>
                            {t(APPROVAL_COMMON_KEYS.REJECT)}
                          </a>
                        </div>
                      )}
                      {roleAccessKey === 'I' && (
                        <a onClick={() => handleDeleteSelect(option)}>
                          {t(APPROVAL_COMMON_KEYS.DELETE)}
                        </a>
                      )}
                      <a onClick={() => downloadFile(option)}>{t(BUTTON_KEYS.DOWNLOAD)}</a>
                    </div>
                  </div>
                )}
                {tabIndex === 2 && (
                  <>
                    {loading && renderLoading()}
                    {authCommentsList.length === 0 && !loading && (
                      <div className='no-data-found'>
                        {t(APPROVAL_COMMON_KEYS.NO_COMMENTS_FOUND)}
                      </div>
                    )}
                    {authCommentsList.length > 0 && <ViewComments comments={authCommentsList} />}
                  </>
                )}
              </div>
            )}
          </div>
        ))}

        {dataSource.length > 5 && (
          <div>
            <CustomPagination
              defaultPageSize={5}
              setMaxValue={(value) => {
                setExpanded(null)
                setMaxValue(value)
              }}
              setMinValue={(value) => setMinValue(value)}
              totalLength={dataSource.length}
              defaultCurrent={1}
            />
          </div>
        )}
      </>
    )
  }

  function renderConfirmation() {
    return (
      <>
        <div className='heading-style'>{t(APPROVAL_SALARY_UPLOAD_KEYS.TITLE)}</div>
        <Formik
          initialValues={{
            comments: '',
          }}
          enableReinitialize
          validationSchema={ApprovalSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='my-4 form-group'>
                <NeoInput
                  mode='textarea'
                  text={t(APPROVAL_COMMON_KEYS.WRITE_COMMENT)}
                  showAsterisk={approvalConfig['isCommentRequired']}
                  name='comments'
                  onChange={handleChange}
                  rows='3'
                />
                <InputError text={errors.comments} touched={touched.comments} />
              </div>

              <div className='mt-3 ml-auto col-12 px-0'>
                {isSubmitting === false ? (
                  <NeoButton
                    type='submit'
                    disabled={isSubmitting}
                    text={t(BUTTON_KEYS.SUBMIT)}
                    mode='newDesign'
                  />
                ) : (
                  renderLoading()
                )}
              </div>
            </Form>
          )}
        </Formik>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </>
    )
  }

  function renderSuccess() {
    return (
      <>
        <div className='bulk-transfer-data bt-style '>
          <div className='heading-style'>{t(APPROVAL_SALARY_UPLOAD_KEYS.TITLE)}</div>
          {responseList.length > 0 && (
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>{t(APPROVAL_SALARY_UPLOAD_KEYS.REFERENCE_NO)}.</th>
                  <th>{t(APPROVAL_COMMON_KEYS.REQUEST_ID)}</th>
                  <th>{t(APPROVAL_COMMON_KEYS.MESSAGE)}</th>
                  <th>{t(APPROVAL_COMMON_KEYS.STATUS)}</th>
                </tr>
              </thead>
              <tbody>
                {responseList.map((option, index) => (
                  <tr key={index}>
                    <td>{option?.referenceNo || '-'}</td>
                    <td>{option?.requestId || '-'}</td>
                    <td>{option?.message}</td>
                    <td>{option?.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <div style={{ width: 150, margin: '30px auto' }}>
            <NeoButton
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => history.push('/approvals')}
              mode='newDesign'
            />
          </div>
        </div>
      </>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      keyPath={'APPROVAL'}
      showEmptySpace={true}
      breadCumKey='APPROVAL_SALARY'>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
